<template>
  <main>
    <div v-if="currentFluxer[0]" class="reporte-feedbacks">
      <headerFeed :currentUser="currentUser" title="Reportes de Feedbacks"></headerFeed>
      <md-spinner v-show="loader" md-indeterminate></md-spinner>
      <md-table v-if="currentFluxer[0].admin">
        <md-table-header>
            <md-table-row>
                <md-table-head>Estado</md-table-head>
                <md-table-head>Tipo</md-table-head>
                <md-table-head>Dueño</md-table-head>
                <md-table-head>Editor</md-table-head>
                <md-table-head>Fecha de solicitud</md-table-head>
                <md-table-head>Fecha de completado</md-table-head>
            </md-table-row>
        </md-table-header>

        <md-table-body>
            <md-table-row @click.native="openDetail(feed)" v-for="(feed, index) in allFeedbacks" :key="index">
                <md-table-cell v-if="feed.completed">Finalizado</md-table-cell>
                <md-table-cell v-else>Pendiente</md-table-cell>
                <md-table-cell v-if="!feed.isEspontaneo">{{feed.tipo}}</md-table-cell>
                <md-table-cell v-if="feed.isEspontaneo">Espontaneo</md-table-cell>
                <md-table-cell>{{feed.owner}}</md-table-cell>
                <md-table-cell>{{feed.editor}}</md-table-cell>
                <md-table-cell>{{feed.created | moment("YYYY/MM/DD - HH:mm")}}</md-table-cell>
                <md-table-cell v-if="feed.completed">{{feed.completed | moment("YYYY/MM/DD - HH:mm")}}</md-table-cell>
                <md-table-cell v-else>-</md-table-cell>
            </md-table-row>
        </md-table-body>
      </md-table>
    </div>
  
    <div v-else>
        Necesita ser Administrador de la app para ver esta seccion
    </div>

    <router-view></router-view>

  </main>
</template>

<script>

import header from './Header'

import Router from '../router'
import FluxerService from '../services/fluxer'
import FeedbacksService from '../services/feedbacks'

export default {
  name: 'reporte-feedbacks',
  components: {
    'headerFeed': header
  },
  data () {
    return {
      loader: false,
      currentUser: FluxerService.getCurrentUser()
    }
  },
  firebase: function () {
    this.loader = true
    return {
      allFeedbacks: {
        source: FeedbacksService.getAllFeedbacks(),
        readyCallback: function () {
          this.loader = false
        }
      },
      currentFluxer: FluxerService.getFluxerByEmail(this.currentUser.email)
    }
  },
  methods: {
    openDetail (feed) {
      Router.push({name: 'feedback-detail-admin', params: {id: feed['.key'], feedback: feed}})
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass">
@import "../sass/variables.scss"

.md-table .md-table-head-container { text-align: center; }

</style>



// WEBPACK FOOTER //
// ReporteFeedbacks.vue?84fd02f0